import { render, staticRenderFns } from "./giftcard-detail.vue?vue&type=template&id=0d4b4051&scoped=true&"
import script from "./giftcard-detail.vue?vue&type=script&lang=js&"
export * from "./giftcard-detail.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-detail.vue?vue&type=style&index=0&id=0d4b4051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b4051",
  null
  
)

export default component.exports